import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AgoraConfigService } from 'src/AgoraConfigService';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AgendaService {
  commonHeaders: any;
  agoraConfigObject: any;
  constructor(private http: HttpClient, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.commonHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
  }
  saveAgendaTimer(timerJson : any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"saveAgendaTimer", timerJson, { headers: this.commonHeaders });
  }
  updateAgendaTimer(timerJson : any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"updateAgendaTimer", timerJson, { headers: this.commonHeaders });
  }

  reviewPAstAgenda(preId:any,json:any){
    return this.http.put<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.agenda}`+"saveReviewPastAgenda/"+preId, json, { headers: this.commonHeaders });
  }
}
